import React from 'react';

const LeftArrow = ({ className = '', strokeWidth = 1.5, stroke = 'var(--foreground)' }) => {
  return (
    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M6.5 11.5L1.5 6.5L6.5 1.5"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeftArrow;
